/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum OMFeatureType {
  Private = "private",
  Tep = "tep",
  Insurance = "insurance",
  HealthContract = "health_contract",
}

export enum InsuranceIncidentType {
  SAI = "SAI",
  TAP = "TAP",
  L = "L",
}

export enum InsurancePayerType {
  V = "V",
  I = "I",
}

export enum InsuranceOptionListing {
  Personal = "personal",
  Employer = "employer",
  Extranet = "extranet",
  ExtranetEmployer = "extranet_employer",
}

export enum InsuranceAdditionalInfoForm {
  OccupationalAccident = "occupational_accident",
  TrafficAccident = "traffic_accident",
  Pohjola = "pohjola",
  Lahitapiola = "lahitapiola",
  IfConsentForm = "if_consent_form",
}

export enum PricingItemType {
  Hinnastokoodi = "hinnastokoodi",
  Hinnastoryhma = "hinnastoryhma",
}

export enum ReferralRequirement {
  Contract = "contract",
  Always = "always",
  Never = "never",
}

export enum CompensationGroupLevel {
  KL1 = "KL1",
  KL2 = "KL2",
  MUU = "MUU",
}

export enum NodeLinkingType {
  Etns = "etns",
  NEtns = "n_etns",
  Palv = "palv",
  Apalv = "apalv",
  Oa = "oa",
  Reason = "reason",
  ParseKey = "parse_key",
}

export enum NotificationServiceType {
  Both = "both",
  Private = "private",
  Ohc = "ohc",
}

export enum ConnectionType {
  Dh = "dh",
  Assisdent = "assisdent",
}

export enum InsurancePaymentOptionListing {
  Personal = "personal",
  Employer = "employer",
  Extranet = "extranet",
  ExtranetEmployer = "extranet_employer",
}

/** Types of suggestions to search for. */
export enum SearchAppointmentSuggestionType {
  Location = "location",
  Node = "node",
  Date = "date",
}

/** Gender to filter specialists by. */
export enum Gender {
  M = "M",
  F = "F",
}

/** Time ranges to filter results by. */
export enum TimeRange {
  Morning = "morning",
  Afternoon = "afternoon",
  Evening = "evening",
}

export enum ContractRuleStatus {
  Allowed = "allowed",
  Disallowed = "disallowed",
  Restriction = "restriction",
  ReferralRequired = "referral_required",
  AssessmentRequired = "assessment_required",
  PaymentCommitmentAllowed = "payment_commitment_allowed",
  PaymentCommitmentDisallowed = "payment_commitment_disallowed",
  CompanyInsurance = "company_insurance",
  DentalRestriction = "dental_restriction",
  BookingPermitAllowed = "booking_permit_allowed",
}

export enum AppointmentSource {
  DH = "DH",
  AssisDent = "AssisDent",
}

export enum ReservationDestinationSystem {
  Dh = "dh",
  Assisdent = "assisdent",
  Docrates = "docrates",
}

export enum BookingNavigation {
  None = "none",
  Docrates = "docrates",
  DocratesAdvancePayment = "docrates_advance_payment",
}

export enum AppointmentType {
  Video = "video",
  Phone = "phone",
  Clinic = "clinic",
  Callback = "callback",
}

export enum ReservationPaymentType {
  Self = "self",
  HealthContract = "health_contract",
  Synsam = "synsam",
  ServiceVoucher = "service_voucher",
  GiftCard = "gift_card",
  PhysiotherapyReferral = "physiotherapy_referral",
  Occupational = "occupational",
  Insurance = "insurance",
  Other = "other",
}

export enum SourceService {
  APP = "APP",
  OM = "OM",
  MDAV = "MDAV",
  MDAV_DH_NAPPI = "MDAV_DH_NAPPI",
  MDAV_DH_VIDEO = "MDAV_DH_VIDEO",
}

/** Linking type (etns for now). */
export enum SearchNodeLinkingType {
  Etns = "etns",
  NEtns = "n_etns",
  Palv = "palv",
  Apalv = "apalv",
  Oa = "oa",
  Reason = "reason",
  ParseKey = "parse_key",
}

export enum NodeFeature {
  SpecialistAppointmentListDisabled = "specialistAppointmentListDisabled",
  AgeCheckEnabled = "ageCheckEnabled",
}

export enum NodeType {
  Default = "default",
  ServicePackage = "service_package",
}

export enum NotificationLinkType {
  Button = "button",
  InlineLink = "inline-link",
}

export enum NotificationStyle {
  Raise = "raise",
  Info = "info",
  WalkIn = "walk-in",
  Error = "error",
  Warning = "warning",
}

export enum NotificationPlacement {
  TopOfSearch = "top_of_search",
  SearchResultsTop = "search_results_top",
  SearchResultsWithin = "search_results_within",
}

export enum NodeServiceType {
  Private = "private",
  Ohc = "ohc",
  Both = "both",
}

export enum ElectronicHealthRecordSystem {
  Dh = "dh",
  Assisdent = "assisdent",
}

export enum SupportedLanguage {
  Fi = "fi",
  En = "en",
  Sv = "sv",
}

export enum LocationType {
  All = "all",
  City = "city",
  Region = "region",
  Clinic = "clinic",
}

export interface ServiceAttachment {
  title: string;
  link: string;
}

export interface BookingInstructions {
  bookingInstructions: string;
  attachments?: ServiceAttachment[];
}

export interface LocationResult {
  type: LocationType;
  id: number;
  uniqueId: string;
  /** DH clinic IDs */
  clinicIDs: string[];
  assisDentBranchIDs: string[];
  name: string;
  address: string | null;
  shortName: string | null;
  phone: string | null;
  imageUrl: string | null;
  lat: number | null;
  long: number | null;
  clinicType: string;
  priority: number;
  favorite: boolean;
  locationTypes: number[];
  defaultNode?: string | null;
  isPublic: boolean;
  city_id?: number | null;
  region_id?: number | null;
}

export interface LanguageResult {
  /** ID of the language */
  id: number;
  /** @example "suomi" */
  language: string;
}

export interface PatientAgeGroup {
  /**
   * ID of the age group.
   * @example 1
   */
  id: number;
  /** Translated description of the age group. */
  patientAgeGroup: string;
}

export interface PriceEstimate {
  /** Service id for which the price estimate is formed. */
  serviceId: number;
  /** Name of the service, translated. */
  name: string;
  /**
   * Minimum price estimate of the service.
   * @example 110.5
   */
  minPrice: number;
  /**
   * Maximum price estimate of the service.
   * @example 150
   */
  maxPrice: number;
  /** Whether the appointment duration affects the price estimate. */
  durationAffectsPrice: boolean;
}

export interface Competence {
  /**
   * Competence ID.
   * @example 124
   */
  id: number;
  /**
   * Competence type. Maps to CompetenceType enum.
   * @example 1
   */
  type: 1 | 2 | 3 | 4 | 5 | 6;
  /** Translated competence as a string. */
  competence: string;
  /**
   * Year when competence achieved, e.g. a completion year of a degree.
   * @example 1990
   */
  year?: number;
}

export interface PractitionerLocation {
  /**
   * Location identifier.
   * @example "T-25"
   */
  id: string;
  /**
   * Name of the location.
   * @example "Kielotie"
   */
  name: string;
}

export interface PractitionerLanguage {
  /**
   * Language name, translated.
   * @example "ruotsi"
   */
  language: string;
  /**
   * Language skill level, translated.
   * @example "työkieli"
   */
  level: string;
}

export interface PatientRestriction {
  /**
   * ID of the restriction.
   * @example 9
   */
  id: number;
  /** Translated description of the restriction. */
  patientRestriction: string;
}

export interface AppointmentLengthOption {
  /**
   * Duration of the option, in minutes.
   * @example 40
   */
  duration: number;
  /**
   * Translated descriptions of the option.
   * @example ["Ajokorttitodistukset ja muut todistukset","Kattavammat lausunnot"]
   */
  description: string[];
  /**
   * Name of the service.
   * @example "Urheiluhieronta"
   */
  serviceName?: string;
  /**
   * (Palveluhaku) ID of the service.
   * @example 1
   */
  serviceId?: number;
}

export interface FlexibleScheduleOption {
  /**
   * (Palveluhaku) ID of the service.
   * @example 563
   */
  serviceId: number;
  /**
   * ID of the location.
   * @example "clinic_443"
   */
  locationId: string;
  /**
   * (DH) ID of the location.
   * @example "M-24"
   */
  locationDHId: string;
  /**
   * Name of the service.
   * @example "Kinesioteippaus"
   */
  serviceName: string;
  /**
   * List of available durations for this service.
   * @example [45,60]
   */
  availableDurations: number[];
  /**
   * List of ETNS (specialties) for this service.
   * @example ["YLE","SIL"]
   */
  etns?: string[];
}

export interface PractitionerNode {
  serviceType: NodeServiceType;
  id: string;
  name: string;
}

export interface AssisDentReason {
  id: string;
  name: string;
  nodeId: string;
}

export interface PractitionerDetails {
  primarySource: ElectronicHealthRecordSystem;
  title: string;
  image?: string;
  rating?: number;
  introduction?: string;
  bookingInstructions?: string;
  testimonial?: string;
  hasFlexibleSchedule?: boolean;
  priceEstimates: PriceEstimate[];
  competencies: Competence[];
  locations: PractitionerLocation[];
  nearFutureLocations: PractitionerLocation[];
  languages: PractitionerLanguage[];
  patientRestrictions: PatientRestriction[];
  patientAgeGroups: PatientAgeGroup[];
  appointmentLengthOptions: AppointmentLengthOption[];
  flexibleScheduleOptions: FlexibleScheduleOption[];
  insuranceContractIds: number[];
  isEntrepreneur: boolean;
  isEmployee: boolean;
  allowsCallbackReservations: boolean;
  nodes: PractitionerNode[];
  assisDentEmployeeId?: string;
  assisDentReasons?: AssisDentReason[];
  isAssisDentMaintenance?: boolean;
  id: number;
  name: string;
}

export interface NotificationLinkList {
  link: string;
  linkText: string;
}

export interface SimpleNotification {
  placements: NotificationPlacement[];
  style: NotificationStyle | null;
  linkType: NotificationLinkType | null;
  isInternalLink: boolean;
  linkText: string | null;
  linkList?: NotificationLinkList[];
  /** @format uuid */
  id: string;
  title: string | null;
  content: string | null;
  icon: string | null;
  link: string | null;
  showRegularAppointments: boolean;
  showVideoAppointments: boolean;
  showPhoneAppointments: boolean;
  searchCountRestrictions: number | null;
}

export interface DCNotification {
  placements: NotificationPlacement[];
  queueLength: number;
  queueId: string;
  ctaText: string;
  /** @format uuid */
  id: string;
  title: string | null;
  content: string | null;
  icon: string | null;
  link: string | null;
  showRegularAppointments: boolean;
  showVideoAppointments: boolean;
  showPhoneAppointments: boolean;
  searchCountRestrictions: number | null;
}

export interface ServiceDetails {
  id: number;
  name: string;
  bookingInstructions?: string;
}

export interface MegaAdminCloseEvent {
  delay: string;
  message?: string;
}

export interface MegaAdminStatus {
  service_enabled: boolean;
  message?: string;
  /** @format date-time */
  delay?: string;
}

export interface DateRange {
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string | null;
}

export interface ContractUsePeriods {
  dates: DateRange[];
  /** @format date-time */
  employmentStarts: string;
  isPaymentCommitmentRequired: boolean;
  userPaymentCommitmentDates: DateRange[];
  namedCheckupOfficeCityId: number;
  isOnlineReservationAllowed: boolean;
}

export interface FeatureFlag {
  name: string;
  value: boolean;
}

export interface PricingItem {
  type: "hinnastoryhma" | "hinnastokoodi";
  value: string;
  parentGroup: string | null;
  isRemote: boolean;
  operator: "and" | "or" | null;
  order: number | null;
}

export interface ContractItem {
  category: string;
  subcategory?: string;
  name: string;
  code: number;
}

export interface SearchNodeService {
  connectionId: string;
  modal: string | null;
  modalOhc: string | null;
  serviceId: string;
  term: string;
  termType:
    | "specialty"
    | "lkri"
    | "expertise"
    | "service"
    | "service_package"
    | "node"
    | "age_group"
    | "reason";
  compensationGroupLevel1: boolean;
  compensationGroupLevel2: boolean;
  compensationGroupLevelOther: boolean;
  pricingItems: PricingItem[];
  remotePricingItems: PricingItem[];
  contractItems: ContractItem[];
  ignoreContractConfirmation: boolean;
  referralRequirementForOHC: "contract" | "always" | "never";
  referralRequiredForPrivateCustomers: boolean;
  dentalContractRestriction: boolean;
}

export interface SearchNodeConnectionCondition {
  id: string;
  propertyPath: string;
  propertyValue: string;
  propertyDataType: string;
  operator: string;
}

export interface SearchNodeTerm {
  id: string;
  type:
    | "specialty"
    | "lkri"
    | "expertise"
    | "service"
    | "service_package"
    | "node"
    | "age_group"
    | "reason";
  term: string;
  freedomOfChoice?: boolean;
}

export interface SearchNodeConnection {
  id: string;
  services?: SearchNodeService[];
  nodeId?: string;
  conditions: SearchNodeConnectionCondition[];
  priority: number;
  type: "dh" | "assisdent";
  terms: SearchNodeTerm[];
  practitionerRestriction: "named_practitioners" | "all_practitioners" | null;
}

export interface SearchNodeWithModals {
  type: NodeType;
  features?: NodeFeature[];
  serviceType: NodeServiceType;
  children?: SearchNodeWithModals[];
  privateCustomerModalId: string;
  ohcPrimaryModalId: string;
  ohcSubstituteModalId: string;
  ohcInterception?: {
    coverage:
      | "allowed"
      | "disallowed"
      | "restriction"
      | "referral_required"
      | "assessment_required"
      | "payment_commitment_allowed"
      | "payment_commitment_disallowed"
      | "company_insurance"
      | "dental_restriction"
      | "booking_permit_allowed";
    allowedForEmployee: boolean;
  };
  reservable: boolean;
  action: "reservation_blocked" | null;
  servicePackageServiceId?: number;
  /** @deprecated */
  remote: boolean;
  showRegardlessOfContract?: boolean;
  showBeforeEmploymentBegins?: boolean;
  connections?: SearchNodeConnection[];
  /** @format uuid */
  id: string;
  name: string;
  descriptionTitle?: string;
  description?: string;
  title?: string;
  caption?: string;
  icon?: string;
  /** @format uuid */
  parentId?: string;
  parentName?: string;
  locationTypes: number[];
  video: boolean;
  phone: boolean;
  redirect?: string;
  /** @format uuid */
  modalId?: string;
  priority: number | null;
  referralLinks: string[];
  isFavorite?: boolean;
  favoriteOrder?: number;
  isListed?: boolean;
}

export interface SearchNodeConnectionBase {
  priority: number;
  type: "dh" | "assisdent";
  terms: SearchNodeTerm[];
  practitionerRestriction: "named_practitioners" | "all_practitioners" | null;
}

export interface PublicNode {
  type: NodeType;
  features?: NodeFeature[];
  children?: PublicNode[];
  /** @format uuid */
  id: string;
  name: string;
  descriptionTitle?: string;
  description?: string;
  title?: string;
  caption?: string;
  icon?: string;
  /** @format uuid */
  parentId?: string;
  parentName?: string;
  locationTypes: number[];
  video: boolean;
  phone: boolean;
  redirect?: string;
  /** @format uuid */
  modalId?: string;
  priority: number | null;
  connections?: SearchNodeConnectionBase[];
  referralLinks: string[];
  isFavorite?: boolean;
  favoriteOrder?: number;
  isListed?: boolean;
}

export interface SearchNodeLinking {
  /** Linking type (etns for now). */
  type: SearchNodeLinkingType;
  numericId: number | null;
  textualId: string | null;
  /**
   * Guid of the node used for searching.
   * @format uuid
   */
  node: string;
  /**
   * Guid for the OHC node used for mapping OHC requets
   * @format uuid
   */
  ohcNode: string | null;
  /** @format uuid */
  modalId: string | null;
  modalAction: string | null;
}

export interface ModalAction {
  title: string;
  /** @format uuid */
  id: string;
  appearance: "primary" | "secondary" | "tertiary";
  type: "close" | "continue" | "digital_clinic" | "node" | "url";
  queue: string | null;
  /** @format uuid */
  node: string | null;
  url: string | null;
}

export interface Modal {
  title: string;
  content: string | null;
  actions: ModalAction[];
  /** @format uuid */
  id: string;
  name: string;
  type:
    | "referral"
    | "referral_tep"
    | "restriction"
    | "not_included"
    | "assessment_required"
    | "payment_commitment_invalid"
    | "payment_commitment_valid"
    | "company_insurance"
    | "own_team"
    | "node"
    | "dental_tep"
    | "om_feature_option"
    | "freedom_of_choice_enabled"
    | "freedom_of_choice_disabled"
    | "freedom_of_choice_redirect"
    | "continuous_care_restriction";
  default: boolean;
  internalDescription: string | null;
}

export interface Address {
  postalCode: string;
  address: string;
  postOffice: string;
}

export interface MarketingPermits {
  permitPhone: boolean;
  permitEmail: boolean;
}

export interface OccupationalAccidentInformation {
  /** @format date-time */
  incidentDate: string;
  /** @maxLength 60 */
  incidentDescription: string;
  /** @maxLength 40 */
  employer: string;
}

export interface TrafficAccidentInformation {
  /** @format date-time */
  incidentDate: string;
  /** @maxLength 60 */
  incidentDescription: string;
  /** @maxLength 10 */
  vehicleRegistrationNumber: string;
}

export interface AccidentDetailsFormData {
  id: string;
  required: boolean;
  value: string;
}

export interface DirectCompensationInformation {
  permitId: string;
  userFormData?: AccidentDetailsFormData[];
}

export interface ReserveInsurance {
  insuranceId: number;
  /** @format uuid */
  paymentTypeId: string;
  occupationalAccidentInformation?: OccupationalAccidentInformation;
  trafficAccidentInformation?: TrafficAccidentInformation;
  directCompensationInformation?: DirectCompensationInformation;
}

export interface ReserveParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  /**
   * The appointment ID. Either DH PTR as a number or internal AssisDent id as a string.
   * @example 1234
   */
  appointmentId: string | number;
  sourceService?: SourceService;
  paymentType?: ReservationPaymentType;
  /** @maxLength 35 */
  firstName: string;
  /** @maxLength 35 */
  lastName: string;
  ssn: string;
  /**
   * Internal flag set by MdavClientFlagMiddleware.
   * Used for conditional validation of phone and email fields.
   * Always overwritten by the middleware - user-supplied values are ignored.
   * Excluded from responses only (toPlainOnly) so it can be read during validation.
   */
  _isMdavClient?: boolean;
  /**
   * Email is required for non-MDAV requests.
   * For MDAV requests, email is optional unless contactByEmail is true.
   * @format email
   * @maxLength 100
   */
  email?: string;
  /**
   * Phone is required for non-MDAV requests.
   * For MDAV requests, phone is optional unless contactBySms is true.
   */
  phone?: string;
  /** Phone appointment number for MDAV requests as there is a dedicated field for it. */
  phoneAppointmentNumber?: string;
  /** @format uuid */
  nodeId?: string;
  /** @format uuid */
  connectionId?: string;
  serviceId?: number;
  specialtyId?: number;
  /**
   * @maxLength 400
   * @default ""
   */
  appointmentReason: string;
  appointmentType: "video" | "phone" | "clinic" | "callback";
  /** @default false */
  isFromApp?: boolean;
  /** @default false */
  isFromOM?: boolean;
  /** @default true */
  sendAttachments?: boolean;
  /** @default true */
  contactByEmail?: boolean;
  /** @default true */
  contactBySms?: boolean;
  minorDisclosureOfInformation?: boolean;
  duration?: number;
  registration?: Address;
  marketingPermits?: MarketingPermits;
  serviceMessagePermit?: boolean;
  insurance?: ReserveInsurance;
  reserveToOmUid?: number;
  discountCode?: string;
  isOhc?: boolean;
  customerNotes?: string;
  paymentNotes?: string;
  selfServiceRestriction?: boolean;
}

export interface ReserveResult {
  /**
   * The appointment ID. Either DH PTR as a number or AssisDent id as a string.
   * @example 1234
   */
  appointmentId: string | number;
  /** Identifier of the created reservation. */
  reservationId: string;
  /** Status message */
  message: string;
  /** Status message */
  videoAppointmentUrl?: string;
}

export interface CancelAppointmentParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  reservationId: string;
}

export interface CancellationInfo {
  appointmentType: AppointmentType;
  locationName?: string;
  locationAddress?: string;
  locationPostalCode?: string;
  locationPostalDistrict?: string;
  bookingNavigation?: string;
  /** @format date-time */
  time: string;
  duration: number;
}

export interface AppointmentReservationInfo {
  type: AppointmentType;
  bookingNavigation: BookingNavigation;
  electronicHealthRecordSystem: "dh" | "assisdent";
  assisdentId?: string;
  /**
   * Date and time of the appointment.
   * @format date-time
   */
  time: string;
  /** Duration of the appointment in minutes. */
  duration: number;
  /** Translated name of the location. */
  locationName: string;
  /** Translated location address. */
  locationAddress: string;
  /** Postal code of the location. */
  locationPostalCode: string;
  /** Postal district of the location. */
  locationPostalDistrict: string;
  locationCoordinates: {
    lat: number | null;
    long: number | null;
  };
  /** Location id. */
  locationId: string;
  /** First and last name of the specialist. */
  specialistName: string;
  /** The translated specialist's title. */
  specialistTitle: string;
  /**
   * A media.mehilainen.fi resource.
   * @example "945979dbf6854066f9e2b19262e8909d.jpg"
   */
  image: string | null;
  /** The translated arrival info. */
  arrivalInfo: string | null;
  /** The translated parking info. */
  parkingInfo: string | null;
  /**
   * Title of the appointment, resolved from the node
   * through which the reservation was made.
   *
   * If no node was used during reservation, this is null.
   */
  appointmentTitle: string | null;
  /** Is the practitioner resource list (RNRO = 50). */
  isResourceList: boolean;
  practitionerId: number;
  minorDisclosureOfInformationForbidden: boolean;
}

export interface UUIDOrIntPipeResult {
  uuid: string | null;
  number: number | null;
}

export interface ReservationPaymentTypesResponse {
  paymentTypes: ReservationPaymentType[];
}

export interface CallbackReservationAllowedParams {
  /**
   * The appointment ID. Either DH PTR as a number or internal AssisDent id as a string.
   * @example 1234
   */
  appointmentId: string | number;
  ssn: string;
  reserveToOmUid?: number;
  isOhc?: boolean;
}

export interface CallbackAllowedResponse {
  callbackAllowed: boolean;
}

export interface ReservationDestinationSystemResult {
  destinationSystem: ReservationDestinationSystem;
}

export interface AppointmentInfoResult {
  /**
   * The appointment ID. Either DH PTR as a number or AssisDent id as a string.
   * @example 1234
   */
  id: string | number;
  appointmentSource: AppointmentSource;
  ohcClinicAppointmentRule?: ContractRuleStatus;
  ohcVideoAppointmentRule?: ContractRuleStatus;
  ohcPhoneAppointmentRule?: ContractRuleStatus;
  etns: string | null;
  etnsA: string | null;
  etnsB: string | null;
  practitionerDhId: string | null;
  practitionerHasFlexibleSchedule: boolean;
  isClinicAppointmentPermitted: boolean;
  isVideoAppointmentPermitted: boolean;
  isPhoneAppointmentPermitted: boolean;
  /** Is the practitioner resource list (RNRO = 50). */
  isResourceList: boolean;
  isCallbackAppointment: boolean;
  isWebAppointment: boolean;
  /** @format date-time */
  date: string;
  duration: number;
  practitionerId: number;
  practitionerName: string;
  practitionerTitle: string;
  practitionerImage: string;
  locationId: string;
  locationName: string;
  locationAddress: string;
  locationPostplace: string;
  locationPostnumber: string;
}

export interface TimeRangeInput {
  /**
   * @min 0
   * @max 23
   */
  start: number;
  /**
   * @min 0
   * @max 24
   */
  end: number;
}

export interface SearchNodeAppointmentsParams {
  /**
   * Time ranges to filter results by.
   * @uniqueItems true
   * @example ["morning","afternoon","evening"]
   */
  timeRanges?: TimeRange[];
  /** @default "fi" */
  lang?: SupportedLanguage;
  /** Gender to filter specialists by. */
  gender?: Gender;
  /**
   * Appointment types to return.
   * @example ["video","phone"]
   */
  appointmentTypes?: AppointmentType[];
  /**
   * Guid of the node used for searching.
   * @format uuid
   */
  id: string;
  /**
   * Startdate for the search.
   * @format date-time
   */
  startDate: string;
  /**
   * @min 1
   * @max 6
   */
  nroOfMonths?: number;
  /**
   * Locations to filter results by.
   * @minItems 1
   * @example ["city2","clinic338"]
   */
  locationIds: string[];
  /**
   * LocationIds converted to internal location ids.
   * @example ["B-11","DOC","E-99","F-21"]
   */
  internalLocationIds?: string[];
  timeRange?: TimeRangeInput;
  durations?: number[];
  /** Patient age group ID to filter specialists by. */
  patientAgeGroupId?: number;
  /** Language ID to filter specialists by. */
  languageId?: number;
  /**
   * Insurance contract ID (Palveluhaku) to filter appointments by.
   * @example 1
   */
  insuranceContractId?: number;
  /** Is this OHC appointment search? */
  isOHC?: boolean;
  offset?: number;
}

export interface ModalContractCondition {
  /** @format uuid */
  id: string;
  numericValue: number | null;
  textualValue: string | null;
  type: "contract_row" | "other";
  action: "skip" | "redirect";
  redirect: string | null;
}

export interface ModalWithContractConditions {
  title: string;
  content: string | null;
  actions: ModalAction[];
  /** @format uuid */
  id: string;
  name: string;
  type:
    | "referral"
    | "referral_tep"
    | "restriction"
    | "not_included"
    | "assessment_required"
    | "payment_commitment_invalid"
    | "payment_commitment_valid"
    | "company_insurance"
    | "own_team"
    | "node"
    | "dental_tep"
    | "om_feature_option"
    | "freedom_of_choice_enabled"
    | "freedom_of_choice_disabled"
    | "freedom_of_choice_redirect"
    | "continuous_care_restriction";
  default: boolean;
  internalDescription: string | null;
  contractCondition: ModalContractCondition | null;
}

export interface AssisDentSearchResult {
  id: string;
  /** @format uuid */
  branchId: string;
  /** @format uuid */
  resourceId: string;
  /** @format uuid */
  reasonId: string;
  /** @format date-time */
  startTime: string;
  /** @format date-time */
  endTime: string;
  length: number;
}

export interface AppointmentSearchResult {
  /** Is the appointment covered by the OHC contract */
  isCoveredByOHC?: ContractRuleStatus;
  /**
   * Date and time of the appointment.
   * @format date-time
   */
  time: string;
  /** Duration of the appointment in minutes. */
  duration: number;
  /** Location of the appointment. */
  location: string;
  /** Numeric ID of the location. */
  locationId?: number;
  /** Translated name of the location. */
  locationName: string;
  locationShortName?: string;
  /** Translated location address. */
  locationAddress: string;
  /** Room identifier of the appointment. */
  locationRoomId?: string;
  /** ID of the specialist. */
  specialistId: number;
  /** First and last name of the specialist. */
  specialistName: string;
  /** The translated specialist's title. */
  specialistTitle: string;
  /** Rating of the specialist if permitted to show. */
  specialistRating?: number;
  /** Whether or not the specialist allows new Kela clients (defaults to true) */
  specialistAllowsNewKelaClients?: boolean;
  /** Is the practitioner resource list (RNRO = 50). */
  isResourceList?: boolean;
  /** Does the practitioner have flexible worklist. */
  hasFlexibleScheduleOptions?: boolean;
  /**
   * A media.mehilainen.fi resource.
   * @example "945979dbf6854066f9e2b19262e8909d.jpg"
   */
  image: string | null;
  /**
   * All possible types of the appointment
   * @example ["clinic","video","phone"]
   */
  appointmentTypes: ("video" | "phone" | "clinic" | "callback")[];
  /** Pointer to the appointment in the dx_aika table (DH). */
  appointmentId?: number;
  /** Appointment search result (AssisDent). */
  assisDentSearchResult?: AssisDentSearchResult;
  /** DEPRECATED: Is the specialist a team member of primary OHC team */
  isPrimaryOHCSpecialist?: boolean;
  /** Is the specialist a team member of primary OHC team, undefined if not */
  primarySpecialistRole?:
    | "TTL"
    | "TTH"
    | "TFT"
    | "TPSY"
    | "YLEL"
    | "RATE"
    | "SOSSU";
  /** Id of the connection that found the appointment. */
  connectionId?: string;
  /** Id of the potential modal shown when clicking the appointment. */
  modalId?: string;
  /** Appointment kind (eg. 'VAST', 'SOIT') for MDAV */
  appointmentKind?: string;
  /** Etns for MDAV and AV */
  etns?: string;
  /** Etns for AV */
  etnsA?: string;
  /** Etns for AV */
  etnsB?: string;
  /**
   * Available duration options for flexible schedule appointments (in minutes).
   * Only populated for appointments with flexible schedules.
   * @example [30,45,60]
   */
  availableDurations?: number[];
  /** Is appointment a web appointment. */
  isWebAppointment?: boolean;
}

export interface SearchAppointmentSuggestion {
  type: "location" | "node" | "date";
  id: string;
  title: string;
  /** @format date-time */
  date?: string;
}

export interface SearchNodeAppointmentResults {
  daysInFuture?: number;
  modals?: ModalWithContractConditions[];
  appointments: AppointmentSearchResult[];
  suggestions: SearchAppointmentSuggestion[] | null;
  hasMoreData: boolean;
}

export interface NodeSearchSuggestionsParams {
  /** Types of suggestions to search for. */
  types: SearchAppointmentSuggestionType[];
  /**
   * Dates after which to search for date suggestions.
   * @format date-time
   */
  datesAfter?: string;
  /** The params to search suggestions for. */
  nodeSearch: SearchNodeAppointmentsParams;
}

export interface CalendarSearchResult {
  /**
   * Date of appointment availability.
   * @format date-time
   * @example "2021-02-25"
   */
  date: string;
  /**
   * Status of availability for the given date.
   * @example true
   */
  isAvailable: boolean;
  /**
   * Callbacks (= 'SOIT') for the given date.
   * @example true
   */
  hasCallbackSlots?: boolean;
  /**
   * Holiday status for the given date (MDAV clients only).
   * @example true
   */
  isHoliday?: boolean;
  /**
   * Weekday status for the given date (MDAV clients only).
   * @example true
   */
  isWeekday?: boolean;
  /**
   * Holiday description for the given date (MDAV clients only).
   * @example "Itsenäisyyspäivä"
   */
  holidayDescription?: string | null;
}

export interface AppointmentSearchByPractitionerParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  /**
   * Appointment types to return.
   * Defaults to [CLINIC, VIDEO, PHONE] if not provided.
   * @uniqueItems true
   * @default ["clinic","video","phone"]
   * @example ["video","phone"]
   */
  appointmentTypes: AppointmentType[];
  /**
   * Time ranges to filter results by.
   * @uniqueItems true
   * @example ["morning","afternoon","evening"]
   */
  timeRanges?: TimeRange[];
  /** Id of the practitioner for whom to search appointments for. */
  practitionerId: number;
  /**
   * Date for the search.
   * @format date-time
   */
  startDate: string;
  /**
   * Locations to filter results by.
   * @minItems 1
   * @uniqueItems true
   * @example ["clinic30","clinic338"]
   */
  location?: string[];
  /** Duration of appointments to search for. */
  duration?: number;
  /**
   * Search by multiple durations.
   * @minItems 1
   */
  durations?: number[];
  /**
   * Palveluhaku palvelu id.
   * Used to filter flexible schedule searches.
   */
  serviceId?: number;
  timeRange?: TimeRangeInput;
  isOhc?: boolean;
  /** @format uuid */
  nodeId?: string;
  /** @format uuid */
  reasonId?: string;
  /**
   * Number of days in future to search for appointments.
   * Requires 'amount' to be set if over 31.
   * @min 0
   * @max 180
   */
  daysInFuture?: number;
}

export interface PractitionerSearchResult {
  appointments: AppointmentSearchResult[];
  suggestions: SearchAppointmentSuggestion[] | null;
}

export interface CallbackSearchByPractitionerParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  /** Practitioner id. */
  practitionerId: number;
  /**
   * Date for the search.
   * @format date-time
   */
  startDate: string;
  /**
   * Number of days in future to search for appointments.
   * Requires 'amount' to be set if over 31.
   * @min 0
   * @max 180
   */
  daysInFuture?: number;
}

export interface CallbackSearchResult {
  /** Is the appointment covered by the OHC contract */
  isCoveredByOHC?: ContractRuleStatus;
  /**
   * Date and time of the appointment.
   * @format date-time
   */
  time: string;
  /** Duration of the appointment in minutes. */
  duration: number;
  /** Location of the appointment. */
  location: string;
  /** Numeric ID of the location. */
  locationId?: number;
  /** Translated name of the location. */
  locationName: string;
  locationShortName?: string;
  /** Translated location address. */
  locationAddress: string;
  /** Room identifier of the appointment. */
  locationRoomId?: string;
  /** ID of the specialist. */
  specialistId: number;
  /** First and last name of the specialist. */
  specialistName: string;
  /** The translated specialist's title. */
  specialistTitle: string;
  /** Rating of the specialist if permitted to show. */
  specialistRating?: number;
  /** Whether or not the specialist allows new Kela clients (defaults to true) */
  specialistAllowsNewKelaClients?: boolean;
  /** Is the practitioner resource list (RNRO = 50). */
  isResourceList?: boolean;
  /** Does the practitioner have flexible worklist. */
  hasFlexibleScheduleOptions?: boolean;
  /**
   * A media.mehilainen.fi resource.
   * @example "945979dbf6854066f9e2b19262e8909d.jpg"
   */
  image: string | null;
  /**
   * All possible types of the appointment
   * @example ["clinic","video","phone"]
   */
  appointmentTypes: ("video" | "phone" | "clinic" | "callback")[];
  /** Pointer to the appointment in the dx_aika table (DH). */
  appointmentId?: number;
  /** Appointment search result (AssisDent). */
  assisDentSearchResult?: AssisDentSearchResult;
  /** DEPRECATED: Is the specialist a team member of primary OHC team */
  isPrimaryOHCSpecialist?: boolean;
  /** Is the specialist a team member of primary OHC team, undefined if not */
  primarySpecialistRole?:
    | "TTL"
    | "TTH"
    | "TFT"
    | "TPSY"
    | "YLEL"
    | "RATE"
    | "SOSSU";
  /** Id of the connection that found the appointment. */
  connectionId?: string;
  /** Id of the potential modal shown when clicking the appointment. */
  modalId?: string;
  /** Appointment kind (eg. 'VAST', 'SOIT') for MDAV */
  appointmentKind?: string;
  /** Etns for MDAV and AV */
  etns?: string;
  /** Etns for AV */
  etnsA?: string;
  /** Etns for AV */
  etnsB?: string;
  /**
   * Available duration options for flexible schedule appointments (in minutes).
   * Only populated for appointments with flexible schedules.
   * @example [30,45,60]
   */
  availableDurations?: number[];
  /** Is appointment a web appointment. */
  isWebAppointment?: boolean;
}

export interface PractitionerCallbackSearchResult {
  appointments: CallbackSearchResult[];
}

export interface AppointmentPriceParams {
  /** @default "fi" */
  lang?: SupportedLanguage;
  /**
   * The appointment ID. Either DH PTR as a number or internal AssisDent id as a string.
   * @example 1234
   */
  appointmentId: string | number;
  /** @format date-time */
  date: string;
  /** @format uuid */
  nodeId?: string;
  /** @format uuid */
  connectionId?: string;
  /** @deprecated */
  specialtyId?: number;
  serviceId?: number;
  duration?: number;
  specialtyIds?: number[];
}

export interface AppointmentPrice {
  source: ElectronicHealthRecordSystem;
  appointmentType: "video" | "phone" | "clinic" | "callback";
  price: number;
  priceAfterKelaCompensation?: number;
  minPrice: number | null;
  maxPrice: number | null;
  minPriceAfterKelaCompensation: number | null;
  maxPriceAfterKelaCompensation: number | null;
  pricingInfo?: string;
  pricingInfoRows?: string;
}

export interface InsurancePayerOption {
  listing: InsurancePaymentOptionListing;
  id: string;
  name: string;
  description: string | null;
  /** @format uuid */
  redirectNodeId: string | null;
  additionalInfoForm: string | null;
  incidentType: string | null;
  /** @format uuid */
  fallbackPaymentOption: string | null;
}

export interface InsuranceCompany {
  id: number;
  name: string;
  bookingInstructions: string | null;
  insurancePayerOptions: InsurancePayerOption[];
  display_group?: number;
}

export interface I18N {
  fi: string;
  sv: string;
  en: string;
}

export interface GetDirectCompensationPermitsResult {
  id: string;
  i18n: {
    title: I18N;
    subtitle: I18N;
    subtitle2: I18N;
    htmlContent?: I18N;
  };
}

export interface GetCustomershipResult {
  hasCustomership: boolean;
  hasPolicyForClaimType: boolean;
  i18n?: {
    failedTitle: I18N;
    failedText: I18N;
  };
}

export interface UserDataForPermit {
  id: string;
  required: boolean;
}

export interface GetOptionsResult {
  id: string;
  icon: string;
  termsUpdated: string | null;
  isTermsAvailable: boolean;
  checkCustomership: boolean;
  userDataForPermit: UserDataForPermit[];
  needsDirectCompensationPermit: boolean;
  clientType: string;
  infoMehiList: object[];
  checkCustomershipUrl: string;
  i18n: {
    name: I18N;
    terms: I18N | null;
    termsTitle: I18N;
    termsCheckbox: I18N;
    agreementText: I18N;
    completedTitle: I18N;
    completedText: I18N;
    completedButton: I18N;
    checkCustomershipTitle: I18N;
    checkCustomershipText: I18N;
    checkCustomershipTextLinkLabels: I18N[];
    checkCustomershipCheckboxText: I18N;
    checkCustomershipButton: I18N;
    usingServiceCheckCustomerShipTitle: I18N;
    usingServiceCheckCustomerShipText: I18N;
    usingServiceCheckCustomerShipCheckBoxText: I18N;
    usingServiceCheckCustomerShipInfoText: I18N;
    usingServiceCheckCustomerShipInfoLinkText: I18N;
  };
}

export interface ConceptConsentStatus {
  showConsentSection: boolean;
  hasActiveConsent?: boolean;
}

export interface UserWithDelegateRole {
  isDelegateUser: boolean;
  id: number;
  fullName: string;
  firstName: string;
  lastName: string;
  ssn: string;
  /** @format email */
  email: string;
  phone: string;
  marketingPermits?: MarketingPermits;
  serviceMessagePermit?: boolean;
  hasAddress: boolean;
  address?: Address;
  omUid: number;
  employeeId?: number;
  companyName?: string;
  isOnlineReservationRestricted?: boolean;
}

export interface SessionInitParams {
  token: string;
}

export interface Service {
  type: string;
  id: object;
}

export interface SessionInitParamsAV2 {
  /** @format base64 */
  userData?: string;
  service?: Service;
  locations?: string;
  language?: string;
  sourceService?: string;
}

export interface AuthorizedPerson {
  omUid: number;
  firstName: string;
  lastName: string;
}

export interface User {
  id: number;
  fullName: string;
  firstName: string;
  lastName: string;
  ssn: string;
  /** @format email */
  email: string;
  phone: string;
  marketingPermits?: MarketingPermits;
  serviceMessagePermit?: boolean;
  hasAddress: boolean;
  address?: Address;
  omUid: number;
  employeeId?: number;
  companyName?: string;
  isOnlineReservationRestricted?: boolean;
}

export interface OmFeatureModalAction {
  action: "close" | "continue" | "digital_clinic" | "node" | "url";
  appearance: "primary" | "secondary" | "tertiary";
  /** @format uri */
  url?: string;
  i18n: {
    title: I18N;
  };
}

export interface OmFeatureModal {
  actions: OmFeatureModalAction[];
  i18n: {
    title: I18N;
    description: I18N;
  };
}

export interface OmFeatureMetadata {
  /** @format uri */
  url?: string;
  serviceId?: string;
  prescriptionId?: string;
  detailType?: string;
  customerType?: string;
  serviceType?: string;
  redirectType?: string;
  actionId?: string;
}

export interface OmFeatureForUser {
  type: "private" | "tep" | "insurance" | "health_contract";
  icon: string | null;
  width: "small" | "large";
  modal?: OmFeatureModal | null;
  action:
    | "asiointi-detail"
    | "asiointi-service"
    | "asiointi-tep"
    | "book-appointment-url"
    | "digital-clinic-service"
    | "digital-clinic-payer-selection"
    | "renew-prescription"
    | "select-insurance-company"
    | "view-customer-service-detail";
  metadata: OmFeatureMetadata;
  i18n: {
    title: I18N;
  };
}

export interface AppointmentLockParams {
  appointmentId: number;
  duration?: number;
  /**
   * @min 300
   * @max 1800
   */
  lockLength?: number;
  /** @format uuid */
  nodeId?: string;
  serviceId?: number;
}

export interface AppointmentLockResult {
  appointmentIds: number[];
  /** @format date-time */
  endDateTime: string;
}

export interface AppointmentUnlockParams {
  /** @uniqueItems true */
  appointmentIds: number[];
}

export interface PractitionerData {
  /** Whether the practitioner has the selected insurance contract. Only set when insuranceContractId query param is provided. */
  hasInsuranceContract?: boolean;
  id: number;
  title: string | null;
  image: string | null;
  privateOnly: boolean;
}

export interface SearchKeywordData {
  id: string;
  numNodes: number;
  nodes: string[];
  keywordServiceType: "private" | "ohc" | "both";
}

export interface NodeData {
  id: string;
  numChildren: number;
  weight: number;
  serviceType: "private" | "ohc" | "both" | null;
  icon?: string;
}

export interface NodeAutocompleteResult {
  keyword: string;
  practitionerData?: PractitionerData;
  searchKeywordData?: SearchKeywordData;
  nodeData?: NodeData;
  groupData?: NodeAutocompleteResult[];
}

export interface NodeAutocompleteResultWithContract {
  /** @example "allowed" */
  contractRuleStatus?: ContractRuleStatus;
  keyword: string;
  practitionerData?: PractitionerData;
  searchKeywordData?: SearchKeywordData;
  nodeData?: NodeData;
  groupData?: NodeAutocompleteResult[];
}

export interface LocationAutocompleteResult {
  type: "all" | "city" | "region" | "clinic";
  id: number;
  clinicIDs: string[];
  name: string;
  address: string | null;
  phone: string | null;
  imageUrl: string | null;
  lat: number | null;
  long: number | null;
  clinicType: string;
  priority: number;
  favorite: boolean;
  locationTypes: number[];
}

export interface ParseBodyParams {
  /** @format base64 */
  userData?: string;
  envelope?: string;
  token?: string;
  sourceService?: "APP" | "OM" | "MDAV" | "MDAV_DH_NAPPI" | "MDAV_DH_VIDEO";
  language?: "fi" | "en" | "sv";
  campaignString?: string;
  selectedOmUid?: number;
}

export interface EventRequestBody {
  id: number;
  appointmentId: UUIDOrIntPipeResult;
  type: "appointment.cancelled" | "appointment.booked";
}

export interface AdminUser {
  role: object;
}

export interface Translation {
  string: string;
  group: string;
  key: string;
  language: string;
}

export interface BaseTranslation {
  group: string;
  key: string;
  language: string;
}

export interface SimpleNode {
  /** @format uuid */
  id: string;
  name: string;
  /** @min 0 */
  primaryConnections: number;
  /** @min 0 */
  secondaryConnections: number;
  /** @min 0 */
  tertiaryConnections: number;
  children: SimpleNode[];
  disabled: boolean;
  priority: number | null;
  icon?: string;
  serviceType: "private" | "ohc" | "both" | null;
}

export interface TranslatedString {
  fi?: string | null;
  en?: string | null;
  sv?: string | null;
}

export interface SearchTerm {
  /** @format uuid */
  id: string;
  type: string;
  term: string;
  serviceTerm: boolean;
  disabled: boolean;
}

export interface ConnectionCondition {
  /** @format uuid */
  id: string;
  /** @format uuid */
  conditionId: string;
  name: string;
  operator?: "and" | "or";
  disabled: boolean;
}

export interface ConnectionOHCOptions {
  practitionerRestriction: "named_practitioners" | "all_practitioners";
}

export interface Connection {
  type: ConnectionType;
  /** @format uuid */
  id: string;
  /** @min 1 */
  priority: number;
  searchTerms: SearchTerm[];
  conditions: ConnectionCondition[];
  ohcOptions: ConnectionOHCOptions | null;
  disabled: boolean;
  ai: boolean | null;
}

export interface SimpleNodeKeyword {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  keyword: string;
  language: "fi" | "en" | "sv";
}

export interface NodeOHCOptions {
  officeRestriction:
    | "employee_team_offices_kl1"
    | "contract_offices_kl2"
    | "all_offices";
  showRegardlessOfContract: boolean;
  showBeforeEmploymentBegins: boolean;
  /** @format uuid */
  primaryModalId?: string;
  /** @format uuid */
  substituteModalId?: string;
}

export interface Node {
  /** @format uuid */
  id: string;
  type: "default" | "service_package";
  serviceType: "private" | "ohc" | "both";
  servicePackageServiceId: number | null;
  servicePackageIsPractitionerService: boolean | null;
  /** @format uuid */
  parentId: string | null;
  name: TranslatedString;
  descriptionTitle: TranslatedString;
  description: TranslatedString;
  title: TranslatedString;
  caption: TranslatedString;
  connections: Connection[];
  disabled: boolean;
  listed: boolean;
  icon:
    | "ui/angle-bottom"
    | "ui/angle-left"
    | "ui/angle-right"
    | "ui/angle-top"
    | "ui/arrow-down-to-line"
    | "ui/arrow-left"
    | "ui/arrow-right"
    | "ui/arrow-up-to-line"
    | "ui/ban"
    | "ui/burger-menu"
    | "ui/caret-left"
    | "ui/caret-right-1"
    | "ui/caret-right"
    | "ui/check-circle"
    | "ui/check"
    | "ui/circle-plus"
    | "ui/circle-times"
    | "ui/clipboard"
    | "ui/clone"
    | "ui/cog"
    | "ui/cogs"
    | "ui/copy"
    | "ui/cut"
    | "ui/double-ellipsis-v"
    | "ui/editor-pen-square"
    | "ui/editor-text"
    | "ui/editor-trash"
    | "ui/ellipsis-h"
    | "ui/ellipsis-v"
    | "ui/external-link"
    | "ui/filter-alt-h"
    | "ui/filter-alt-v"
    | "ui/filter-h"
    | "ui/filter-v"
    | "ui/filter"
    | "ui/fingerprint"
    | "ui/folder-open"
    | "ui/folder"
    | "ui/H1"
    | "ui/list-ul"
    | "ui/long-arrow-left"
    | "ui/long-arrow-right"
    | "ui/minus-circle"
    | "ui/minus"
    | "ui/network-lost"
    | "ui/network"
    | "ui/paperclip"
    | "ui/paste"
    | "ui/pen"
    | "ui/plus"
    | "ui/redo"
    | "ui/save"
    | "ui/search"
    | "ui/sign-in"
    | "ui/sign-out-alt"
    | "ui/sign-out"
    | "ui/sliders-h-square"
    | "ui/tasks"
    | "ui/thumbtack"
    | "ui/times"
    | "ui/upload"
    | "ui/value-absolute"
    | "services/baby"
    | "services/body-allergy"
    | "services/body-bones"
    | "services/body-brains"
    | "services/body-joint"
    | "services/body-lips"
    | "services/body-spine"
    | "services/briefcase"
    | "services/childrens-mehilainen"
    | "services/digiklinikka"
    | "services/disease"
    | "services/egg-cell"
    | "services/eye"
    | "services/flask"
    | "services/hand-holding-heart"
    | "services/hand-holding-medical"
    | "services/handshake"
    | "services/imaging"
    | "services/laboratory"
    | "services/memory"
    | "services/mental-health"
    | "services/mind-bubble"
    | "services/plaster"
    | "services/siren-on"
    | "services/stethoscope"
    | "services/surface"
    | "services/syringe"
    | "services/tennis-ball"
    | "services/tooth"
    | "services/umbrella"
    | "services/vial"
    | "services/vials"
    | "services/body-joint-alt"
    | "services/clinical-physiology"
    | "services/ear"
    | "services/ekg"
    | "services/general-surgery"
    | "services/head-side-cough"
    | "services/lungs"
    | "services/operation"
    | "services/ribbon"
    | "services/sparkles"
    | "services/stomach"
    | "services/dental-x-ray"
    | "services/foot"
    | "services/mammogram"
    | "services/medical-cross"
    | "services/mri"
    | "services/physiotherapy"
    | "services/ultrasound"
    | "services/x-ray"
    | "persons/child"
    | "persons/icon"
    | "persons/user-clock"
    | "persons/user-cog"
    | "persons/user-friends"
    | "persons/user-lock"
    | "persons/user-md-chat"
    | "persons/user-md"
    | "persons/user-minus"
    | "persons/user-nurse"
    | "persons/user-plus"
    | "persons/user-secret"
    | "persons/user-tie"
    | "persons/user"
    | "persons/users-cog"
    | "persons/users-medical"
    | "persons/users-slash"
    | "persons/users"
    | "persons/elderly"
    | "persons/user-slash"
    | "persons/user-specialist"
    | "persons/user-times"
    | "persons/user-bandage"
    | "persons/user-injured"
    | "travel/car-side"
    | "travel/crosshairs"
    | "travel/globe"
    | "travel/location-arrow"
    | "travel/location-circle"
    | "travel/location"
    | "travel/map-marker-check"
    | "travel/map-marker"
    | "travel/map-pin"
    | "travel/parking-circle"
    | "travel/route"
    | "travel/transportation-plane"
    | "travel/transportation-truck"
    | "app-navigation/booking-inactive"
    | "app-navigation/booking-selected"
    | "app-navigation/calendar-inactive"
    | "app-navigation/calendar-selected"
    | "app-navigation/chroniccare-inactive"
    | "app-navigation/chroniccare-selected"
    | "app-navigation/digiklinikka-inactive"
    | "app-navigation/digiklinikka-selected"
    | "app-navigation/home-inactive"
    | "app-navigation/home-selected"
    | "app-navigation/laboratory-inactive"
    | "app-navigation/laboratory-selected"
    | "app-navigation/messages-inactive"
    | "app-navigation/messages-selected"
    | "app-navigation/more-inactive"
    | "app-navigation/more-selected"
    | "app-navigation/occupational-inactive"
    | "app-navigation/occupational-selected"
    | "app-navigation/profile-inactive"
    | "app-navigation/profile-selected"
    | "app-navigation/report-inactive"
    | "app-navigation/report-selected"
    | "app-navigation/search-inactive"
    | "app-navigation/search-selected"
    | "app-navigation/careplans-selected"
    | "app-navigation/events-selected"
    | "app-navigation/settings-selected"
    | "brand/mehilainen"
    | "dental/chipped-tooth"
    | "misc/ballot-check"
    | "misc/book-medical"
    | "misc/box"
    | "misc/cabinet-filing"
    | "misc/car-crash"
    | "misc/card-credit"
    | "misc/card-id"
    | "misc/circle (solid)"
    | "misc/coin"
    | "misc/diet"
    | "misc/editor-image"
    | "misc/eye-low-vision"
    | "misc/file-signature-landscape"
    | "misc/file-signature"
    | "misc/file"
    | "misc/gift-card"
    | "misc/gift"
    | "misc/glasses-round"
    | "misc/graduation-cap"
    | "misc/hashtag"
    | "misc/hat-wizard"
    | "misc/heart"
    | "misc/hourglass"
    | "misc/laptop-code"
    | "misc/pie-chart"
    | "misc/poll-h"
    | "misc/portion-large"
    | "misc/portion-medium"
    | "misc/portion-small"
    | "misc/receipt"
    | "misc/rectangle-history"
    | "misc/rectangle"
    | "misc/salad"
    | "misc/seedling"
    | "misc/shield"
    | "misc/smile-beam"
    | "misc/star"
    | "misc/tag-vertical"
    | "misc/tag"
    | "misc/thumbs-down"
    | "misc/thumbs-up"
    | "misc/trophy"
    | "misc/typewriter"
    | "misc/user-clipboard-user"
    | "misc/utensils"
    | "misc/water-lily"
    | "misc/video"
    | "misc/viruses"
    | "misc/adjust"
    | "misc/align"
    | "misc/bacteria"
    | "misc/clipboard-medical"
    | "misc/coffee-solid"
    | "misc/coffee"
    | "misc/drafting-compass"
    | "misc/half-star"
    | "misc/laptop-medical"
    | "misc/medical-case"
    | "misc/new-receipt"
    | "misc/qestionnaire"
    | "misc/robot-filled"
    | "misc/robot"
    | "misc/scalpel"
    | "misc/send"
    | "misc/star-filled"
    | "misc/sticky-note-empty"
    | "misc/sticky-note"
    | "misc/table"
    | "misc/virus"
    | "misc/gem"
    | "nutrition/toothbrush"
    | "time/calendar-1"
    | "time/calendar-check"
    | "time/calendar-day"
    | "time/calendar-exclamation"
    | "time/calendar-plus"
    | "time/calendar"
    | "time/clock"
    | "time/hourglass"
    | "measure/activity"
    | "measure/bloodsugar"
    | "measure/chart-bar"
    | "measure/circle-notch"
    | "measure/heart-sensor"
    | "measure/ruler"
    | "measure/running"
    | "measure/shoe-prints"
    | "measure/snooze"
    | "measure/stopwatch"
    | "measure/tachometer"
    | "measure/weight"
    | "communication/comment-alt"
    | "communication/comment-medical"
    | "communication/comment"
    | "communication/comments-alt"
    | "communication/comments"
    | "communication/envelope"
    | "communication/headset"
    | "communication/phone"
    | "communication/smartphone"
    | "communication/comment-alt-check"
    | "communication/comment-alt-lines"
    | "communication/headphones"
    | "communication/phone-question-mark"
    | "communication/paper-plane"
    | "gender/gender-female-male"
    | "gender/gender-female"
    | "gender/gender-male"
    | "buildings/building"
    | "buildings/city"
    | "buildings/home"
    | "buildings/hospital-alt"
    | "buildings/hospital-user"
    | "buildings/hospital"
    | "buildings/hospital-solid"
    | "instructions/hand-paper"
    | "instructions/hand-rock"
    | "instructions/handwash"
    | "instructions/head-side-mask"
    | "instructions/head-side"
    | "instructions/smoking-ban"
    | "toggle/bell-selected"
    | "toggle/bell"
    | "toggle/checkbox-off"
    | "toggle/checkbox-on"
    | "toggle/eye-hidden"
    | "toggle/eye-visible"
    | "toggle/lock-alt"
    | "toggle/lock-open-alt"
    | "toggle/minus-square"
    | "toggle/plus-square"
    | "toggle/radio-off"
    | "toggle/radio-on"
    | "toggle/sort-down-2"
    | "toggle/sort-down"
    | "toggle/sort-up-2"
    | "toggle/sort-up"
    | "toggle/sort"
    | "toggle/toggle-off"
    | "toggle/toggle-on"
    | "notification/circle-info"
    | "notification/exclamation-circle"
    | "notification/exclamation-square"
    | "notification/exclamation-triangle"
    | "notification/question-circle"
    | "alert/error"
    | "alert/information"
    | "alert/success"
    | "alert/warning"
    | "social-media/blog-neg"
    | "social-media/blog-pos"
    | "social-media/facebook-neg"
    | "social-media/facebook-pos"
    | "social-media/facebook"
    | "social-media/instagram-neg"
    | "social-media/instagram-pos"
    | "social-media/instagram"
    | "social-media/linkedin-neg"
    | "social-media/linkedin-pos"
    | "social-media/linkedin"
    | "social-media/snapchat-neg"
    | "social-media/snapchat-pos"
    | "social-media/snapchat"
    | "social-media/twitter-neg"
    | "social-media/twitter"
    | "social-media/witter-pos"
    | "social-media/youtube-neg"
    | "social-media/youtube-pos"
    | "social-media/youtube"
    | "user/surprised"
    | null;
  keywords: SimpleNodeKeyword[];
  locationTypes: number[];
  video: boolean;
  phone: boolean;
  redirect: string | null;
  ohcOptions: NodeOHCOptions | null;
  /** @format uuid */
  modalId: string | null;
  priority: number | null;
  /** @format date-time */
  created: string | null;
  /** @format date-time */
  modified: string | null;
  /** @format uuid */
  bookingPermit: string | null;
  referralLinks: string[];
  features: ("specialistAppointmentListDisabled" | "ageCheckEnabled")[];
  discounts: string[];
}

export interface NodeChildren {
  /** @minItems 1 */
  children: string[];
}

export interface FavoriteNode {
  /** @format uuid */
  favoriteId: string;
  /** @format uuid */
  nodeId: string;
  order: number;
  disabled: boolean;
  visibleIn: string;
}

export interface SearchTermOption {
  type: string;
  term: string;
  name: string;
  group: string | null;
  ai: boolean | null;
}

export interface NodeIcon {
  id: object;
  path: string;
}

export interface NodeKeyword {
  /** @format uuid */
  id: string;
  /** @maxLength 150 */
  keyword: string;
  language: "fi" | "en" | "sv";
  disabled: boolean;
  connectedNodes: string[];
}

export interface ConditionOption {
  /** @format uuid */
  id: string;
  name: string;
  disabled: boolean;
}

export interface Location {
  id: number;
  name: string;
  type: string;
}

export interface NotificationPlace {
  type: "top_of_search" | "search_results_top" | "search_results_within";
  name?: string;
}

export interface NotificationNode {
  /** @format uuid */
  id: string;
  name?: string;
  serviceType: "private" | "ohc" | "both" | null;
}

export interface Notification {
  serviceType: NotificationServiceType | null;
  style: string | null;
  link: TranslatedString | null;
  linkText: TranslatedString | null;
  isInternalLink: boolean | null;
  linkType: "button" | "inline-link" | null;
  /** @format uuid */
  id: string;
  name: string;
  title: TranslatedString;
  disabled: boolean;
  icon: string | null;
  content: TranslatedString | null;
  /** @format date-time */
  displayStartDate: string | null;
  /** @format date-time */
  displayEndDate: string | null;
  showRegularAppointments: boolean;
  showVideoAppointments: boolean;
  showPhoneAppointments: boolean;
  searchCountRestrictions: number | null;
  locations: Location[];
  places: NotificationPlace[];
  nodes: NotificationNode[];
  showInAllLocations: boolean;
  showInAllNodes: boolean;
}

export interface WalkInNotification {
  id: number;
  name: string;
  connectedNodes: string[];
}

export interface NotificationContractCondition {
  /** @format uuid */
  id: string;
  numericValue: number | null;
  textualValue: string | null;
  type: "contract_row" | "other";
}

export interface DigitalClinicNotification {
  serviceType: NotificationServiceType | null;
  queue: string;
  queueMaxLength: number;
  callToAction: TranslatedString;
  contractCondition: NotificationContractCondition | null;
  /** @format uuid */
  id: string;
  name: string;
  title: TranslatedString;
  disabled: boolean;
  icon: string | null;
  content: TranslatedString | null;
  /** @format date-time */
  displayStartDate: string | null;
  /** @format date-time */
  displayEndDate: string | null;
  showRegularAppointments: boolean;
  showVideoAppointments: boolean;
  showPhoneAppointments: boolean;
  searchCountRestrictions: number | null;
  locations: Location[];
  places: NotificationPlace[];
  nodes: NotificationNode[];
  showInAllLocations: boolean;
  showInAllNodes: boolean;
}

export interface DigitalClinicQueue {
  id: string;
  name: string;
}

export interface NodeLinking {
  type: NodeLinkingType;
  /** @format uuid */
  id: string | null;
  textual_id: string | null;
  numeric_id: number | null;
  name: string;
  bookable: boolean;
  /** @format uuid */
  node: string | null;
  /** @format uuid */
  ohc_node: string | null;
  modal_id: string | null;
  modal_name: string | null;
  /** @maxLength 100 */
  modal_action: string | null;
}

export interface NodeLinkingParams {
  type: NodeLinkingType;
  /** @format uuid */
  id: string | null;
  textual_id: string | null;
  numeric_id: number | null;
  /** @format uuid */
  node: string;
  /** @format uuid */
  ohc_node: string | null;
  /** @format uuid */
  modal_id: string | null;
  /** @maxLength 100 */
  modal_action: string | null;
}

export interface NodeLocationType {
  id: number;
  name: string;
}

export interface LocationSettings {
  id: number;
  name: string;
  type: NodeLocationType[];
  /** @format uuid */
  defaultNode?: string;
}

export interface AdminNodeServicePricingItem {
  /** @maxLength 128 */
  type: PricingItemType;
  /** @format uuid */
  id: string;
  /** @maxLength 128 */
  value: string;
  remote: boolean;
  operator: "and" | "or" | null;
}

export interface AdminNodeServiceContractItem {
  /** @format uuid */
  id: string;
  code: number;
}

export interface AdminNodeService {
  /** @maxLength 128 */
  type: NodeServiceType;
  compensationGroupLevels: CompensationGroupLevel[];
  referralRequirementForOhc: ReferralRequirement;
  /** @format uuid */
  id: string;
  name: string;
  /** @maxLength 256 */
  term: string;
  availableInOhc: boolean;
  contracts: AdminNodeServicePricingItem[];
  remoteContracts: AdminNodeServicePricingItem[];
  contractItems: AdminNodeServiceContractItem[];
  ignoreContractConfirmation: boolean;
  referralRequiredForPrivateCustomers: boolean;
  disabled: boolean;
  /** @format uuid */
  modal: string | null;
  /** @format uuid */
  modalOhc: string | null;
  dentalContractRestriction: boolean;
}

export interface AdminNodeServiceOption {
  type: NodeServiceType;
  /** @maxLength 256 */
  id: string;
  name: string;
}

export interface AdminNodeServicePricingOption {
  type: PricingItemType;
  /** @maxLength 128 */
  id: string;
  name: string;
}

export interface ServiceLinking {
  /** @format uuid */
  id: string | null;
  etns: string | null;
  name: string;
  bookable: boolean;
  /** @format uuid */
  service: string | null;
  /** @format date-time */
  modified_dt: string | null;
}

export interface ServiceLinkingParams {
  /** @format uuid */
  id: string | null;
  etns: string;
  /** @format uuid */
  service: string;
}

export interface AdminModalAction {
  title: TranslatedString;
  /** @format uuid */
  id: string;
  appearance: "primary" | "secondary" | "tertiary";
  type: "close" | "continue" | "digital_clinic" | "node" | "url";
  queue: string | null;
  /** @format uuid */
  node: string | null;
  url: TranslatedString;
}

export interface ModalLinkedNode {
  /** @format uuid */
  nodeId: string;
  type: string;
}

export interface ModalLinkedLinking {
  /** @format uuid */
  linkingId: string;
  textualId: string;
  modalAction: string;
}

export interface AdminModal {
  title: TranslatedString;
  content: TranslatedString | null;
  contractCondition: ModalContractCondition | null;
  actions: AdminModalAction[];
  nodes: ModalLinkedNode[];
  linkings: ModalLinkedLinking[];
  /** @format uuid */
  id: string;
  name: string;
  type:
    | "referral"
    | "referral_tep"
    | "restriction"
    | "not_included"
    | "assessment_required"
    | "payment_commitment_invalid"
    | "payment_commitment_valid"
    | "company_insurance"
    | "own_team"
    | "node"
    | "dental_tep"
    | "om_feature_option"
    | "freedom_of_choice_enabled"
    | "freedom_of_choice_disabled"
    | "freedom_of_choice_redirect"
    | "continuous_care_restriction";
  default: boolean;
  internalDescription: string | null;
}

export interface AssisdentMaintenanceParams {
  enable: boolean;
  maintenanceParams: {
    IsMaintenanceMode: boolean;
    StartTimeUtc?: string;
    IsMaintenanceScheduled: boolean;
  };
}

export interface ParseSelection {
  id: string;
  name: string;
  disabled?: boolean;
}

export interface ParseSelections {
  specialties: ParseSelection[];
  areaOfExpertises: ParseSelection[];
  services: ParseSelection[];
  reasons: ParseSelection[];
  clinics: ParseSelection[];
  areas: ParseSelection[];
}

export interface RequiredTranslatedString {
  fi: string;
  en: string;
  sv: string;
}

export interface InsuranceOption {
  additionalInfoForm: InsuranceAdditionalInfoForm | null;
  listing: InsuranceOptionListing;
  timeslotPayerType: InsurancePayerType;
  incidentType: InsuranceIncidentType;
  /** @format uuid */
  id: string;
  insuranceId: number;
  insuranceName: string | null;
  dhAppointmentReasonText: string | null;
  dhPaymentTermText: string | null;
  assisdentAdditionalInfoText: string | null;
  name: RequiredTranslatedString;
  description: TranslatedString;
  order: number | null;
  timeslotPayerText: string | null;
  createReferral: boolean;
  referralPayerType: string | null;
  careChainPayer: number | null;
  careChainInsuranceNumber: string | null;
  /** @format uuid */
  redirectNodeId: string | null;
  /** @maxLength 50 */
  careChainIncidentNumber: string | null;
  /** @maxLength 200 */
  careChainTitle: string | null;
  /** @maxLength 200 */
  careChainReason: string | null;
  /** @maxLength 1000 */
  careChainText: string | null;
  careChainWithoutDirectCompensation: boolean | null;
  /** @format uuid */
  fallbackPaymentOption: string | null;
  hideFromReservation: boolean | null;
}

export interface OmFeatureContractCondition {
  /** @format uuid */
  id: string;
  numericValue: number | null;
  textualValue: string | null;
  type: "contract_row" | "other";
}

export interface OmFeature {
  type: OMFeatureType;
  /** @format uuid */
  id: string;
  title: TranslatedString;
  icon: string | null;
  public: boolean | null;
  presentation: string | null;
  /** @format uuid */
  modal: string | null;
  /** @format uuid */
  secondaryModal: string | null;
  contractCondition: OmFeatureContractCondition | null;
  order: number | null;
  description: TranslatedString;
  action:
    | "asiointi-detail"
    | "asiointi-service"
    | "asiointi-tep"
    | "book-appointment-url"
    | "digital-clinic-service"
    | "digital-clinic-payer-selection"
    | "renew-prescription"
    | "select-insurance-company"
    | "view-customer-service-detail";
  subAction: string | null;
}

export interface OmFeatureOrder {
  type: OMFeatureType;
  ids: string[];
}

export interface SearchThresholdItem {
  /** @format uuid */
  threshold_id: string | null;
  node: string;
  /** @format uuid */
  node_id: string;
  service_type: string;
  location: string[];
  location_ids: string[];
  secondary_threshold: number | null;
  tertiary_threshold: number | null;
}

export type AvailabilityCheckNodeOverrides = object;

export interface AvailabilityCheckConfigDto {
  /**
   * @min 0
   * @max 1
   */
  globalPercentage: number;
  nodeOverrides?: AvailabilityCheckNodeOverrides;
}

export interface AvailabilityCheckConfigValueDto {
  value: AvailabilityCheckConfigDto;
}

export interface ConfigValueDto {
  /**
   * @min 0
   * @max 1
   */
  value: number;
}

export interface CreateTestAppointmentsParams {
  /** @format uuid */
  testId?: string;
  duration: number;
  /** @format date-time */
  datetime: string;
  nrOfAppointments: number;
  practitioner: string;
  etns: string;
  office: string;
}

export interface CreateTestAppointmentsResult {
  testId: string;
  ptr: number;
}

export interface FlexibleService {
  durations: number[];
  serviceId: number;
  locationId: number;
}

export interface CombinedAppointment {
  duration: number;
  descriptionFi: string;
  descriptionEn?: string;
  descriptionSv?: string;
}

export interface CreateTestPractitionerParams {
  /** @format uuid */
  testId?: string;
  firstName: string;
  lastName: string;
  services?: Service[];
  flexibleServices?: FlexibleService[];
  contracts?: number[];
  patientGroups?: number[];
  patientRestrictions?: number[];
  allowedAgeGroups?: number[];
  combinedAppointments?: CombinedAppointment[];
}

export interface CreateTestPractitionerResult {
  testId: string;
  dhId: string;
  palveluhakuId: string;
}

export interface DeleteTestDataParams {
  /** @format uuid */
  testId?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Mehiläinen AV API
 * @version 96.3.0
 * @contact
 *
 * Mehiläinen Ajanvaraus API:n kuvaus
 */
export class Api<
  SecurityDataType extends unknown,
  IHttpClient extends HttpClient<SecurityDataType>,
> {
  http: IHttpClient;

  constructor(http: IHttpClient) {
    this.http = http;
  }

  v1 = {
    /**
     * No description
     *
     * @tags public
     * @name GetLocations
     * @request GET:/v1/public/locations
     */
    getLocations: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationResult[], any>({
        path: `/v1/public/locations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetGeolocateResults
     * @request GET:/v1/public/locations/geolocate
     */
    getGeolocateResults: (
      query: {
        lang: "fi" | "en" | "sv";
        lat: number;
        long: number;
        /** @deprecated */
        acceptedLocationTypes?: number[];
        /** @format uuid */
        nodeId?: string;
        isOHC?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationResult[], any>({
        path: `/v1/public/locations/geolocate`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetLanguages
     * @request GET:/v1/public/languages
     */
    getLanguages: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LanguageResult[], any>({
        path: `/v1/public/languages`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetAgeGroups
     * @request GET:/v1/public/age-groups
     */
    getAgeGroups: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PatientAgeGroup[], any>({
        path: `/v1/public/age-groups`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetPractitionerDetails
     * @request GET:/v1/public/practitioner-details
     */
    getPractitionerDetails: (
      query: {
        lang?: SupportedLanguage;
        practitionerId: number;
        isOhc?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PractitionerDetails, any>({
        path: `/v1/public/practitioner-details`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name Translations
     * @request GET:/v1/public/translations
     */
    translations: (params: RequestParams = {}) =>
      this.http.request<AvailabilityCheckNodeOverrides, any>({
        path: `/v1/public/translations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetNotifications
     * @request GET:/v1/public/notifications
     */
    getNotifications: (
      query: {
        lang: string;
        locations: string[];
        nodeId: string;
        isOHC: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SimpleNotification[], any>({
        path: `/v1/public/notifications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetDkNotifications
     * @request GET:/v1/public/digitalclinic-notifications
     */
    getDkNotifications: (
      query: {
        lang: string;
        locations: string[];
        nodeId: string;
        isOHC: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DCNotification[], any>({
        path: `/v1/public/digitalclinic-notifications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetServiceName
     * @request GET:/v1/public/service-name
     */
    getServiceName: (
      query: {
        lang: string;
        serviceId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ServiceDetails, any>({
        path: `/v1/public/service-name`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags public
     * @name GetBookingInstructions
     * @request GET:/v1/public/booking-instructions
     */
    getBookingInstructions: (
      query: {
        lang: string;
        serviceId?: number;
        nodeId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<BookingInstructions | null, any>({
        path: `/v1/public/booking-instructions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name GetContract
     * @request GET:/v1/ohc/contract
     */
    getContract: (params: RequestParams = {}) =>
      this.http.request<AvailabilityCheckNodeOverrides, any>({
        path: `/v1/ohc/contract`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name GetContractDates0
     * @request GET:/v1/ohc/contract-dates
     */
    getContractDates0: (params: RequestParams = {}) =>
      this.http.request<ContractUsePeriods, any>({
        path: `/v1/ohc/contract-dates`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name GetContractDates1
     * @request GET:/v1/ohc/contract-info
     */
    getContractDates1: (params: RequestParams = {}) =>
      this.http.request<ContractUsePeriods, any>({
        path: `/v1/ohc/contract-info`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name GetOhcLocations
     * @request GET:/v1/ohc/locations
     */
    getOhcLocations: (
      query: {
        lang: string;
        nodeId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationResult[], any>({
        path: `/v1/ohc/locations`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ohc
     * @name IsPricingItemCoveredByContract
     * @request GET:/v1/ohc/contract-coverage
     */
    isPricingItemCoveredByContract: (
      query: {
        employeeId?: number;
        companyId?: number;
        type: "hinnastoryhma" | "hinnastokoodi";
        value: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AvailabilityCheckNodeOverrides, any>({
        path: `/v1/ohc/contract-coverage`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags settings
     * @name FeatureFlags
     * @request GET:/v1/settings/feature-flags
     */
    featureFlags: (params: RequestParams = {}) =>
      this.http.request<FeatureFlag[], any>({
        path: `/v1/settings/feature-flags`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name SearchNode
     * @request GET:/v1/search-nodes
     */
    searchNode: (
      query?: {
        lang?: SupportedLanguage;
        /** @format uuid */
        nodeId?: string;
        /** @format uuid */
        keywordId?: string;
        /**
         * @minLength 3
         * @maxLength 128
         */
        keyword?: string;
        isOhc?: boolean;
        onlyListed?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeWithModals[] | PublicNode[], any>({
        path: `/v1/search-nodes`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name FavoriteNodes
     * @request GET:/v1/search-nodes/favorites
     */
    favoriteNodes: (
      query: {
        menu: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeWithModals[] | PublicNode[], any>({
        path: `/v1/search-nodes/favorites`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name SearchNodes
     * @request GET:/v1/search-nodes/listed
     */
    searchNodes: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PublicNode[], any>({
        path: `/v1/search-nodes/listed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name AllNodes
     * @request GET:/v1/search-nodes/all
     */
    allNodes: (
      query: {
        lang: string;
        isOhc: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeWithModals[] | PublicNode[], any>({
        path: `/v1/search-nodes/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name SearchNodeLinkings
     * @request GET:/v1/search-nodes/linkings
     */
    searchNodeLinkings: (params: RequestParams = {}) =>
      this.http.request<SearchNodeLinking[], any>({
        path: `/v1/search-nodes/linkings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes
     * @name GetOhcNodes
     * @request GET:/v1/search-nodes/ohc/listed
     */
    getOhcNodes: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PublicNode[], any>({
        path: `/v1/search-nodes/ohc/listed`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags modals
     * @name GetModals
     * @request GET:/v1/modals
     */
    getModals: (
      query: {
        lang: string;
        isOHC: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<Modal[], any>({
        path: `/v1/modals`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name Reserve
     * @request POST:/v1/reservations
     */
    reserve: (data: ReserveParams, params: RequestParams = {}) =>
      this.http.request<ReserveResult, any>({
        path: `/v1/reservations`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name CancelAppointment
     * @request DELETE:/v1/reservations
     */
    cancelAppointment: (
      data: CancelAppointmentParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/v1/reservations`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name CancellationInfo
     * @request GET:/v1/reservations/cancellation-info
     */
    cancellationInfo: (
      query: {
        lang?: SupportedLanguage;
        reservationId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CancellationInfo, any>({
        path: `/v1/reservations/cancellation-info`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name ReservationInfo
     * @request GET:/v1/reservations/reservation-info
     */
    reservationInfo: (
      query: {
        reservationId: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentReservationInfo, any>({
        path: `/v1/reservations/reservation-info`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name NotificationInfo
     * @request GET:/v1/reservations/notification-info
     */
    notificationInfo: (
      query: {
        appointmentId: UUIDOrIntPipeResult;
        action: string;
        userPid: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AvailabilityCheckNodeOverrides, any>({
        path: `/v1/reservations/notification-info`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name ReservationPaymentTypes
     * @request GET:/v1/reservations/reservation-payment-types
     */
    reservationPaymentTypes: (
      query: {
        /** The appointment ID. Either DH PTR or internal AssisDent id as a string. */
        appointmentId: string;
        isOhc?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ReservationPaymentTypesResponse, any>({
        path: `/v1/reservations/reservation-payment-types`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name CallbackReserveAllowed
     * @request POST:/v1/reservations/callback-reserve-allowed
     */
    callbackReserveAllowed: (
      data: CallbackReservationAllowedParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CallbackAllowedResponse, any>({
        path: `/v1/reservations/callback-reserve-allowed`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags reservations
     * @name GetReservationDestinationSystem
     * @request GET:/v1/reservations/reservation-destination-system
     */
    getReservationDestinationSystem: (
      query: {
        nodeId?: string;
        serviceId?: number;
        appointmentId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ReservationDestinationSystemResult, any>({
        path: `/v1/reservations/reservation-destination-system`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name AppointmentInfo
     * @request GET:/v1/appointments
     */
    appointmentInfo: (
      query: {
        lang?: SupportedLanguage;
        /** The appointment ID. Either DH PTR or internal AssisDent id as a string. */
        appointmentId: string;
        /** @format uuid */
        nodeId?: string;
        /** @format uuid */
        connectionId?: string;
        isOHC?: boolean;
        duration?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentInfoResult, any>({
        path: `/v1/appointments`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name GetAppointmentLengthOptions
     * @request GET:/v1/appointments/appointment-length-options
     */
    getAppointmentLengthOptions: (
      query: {
        lang?: SupportedLanguage;
        appointmentId: number;
        /** @format uuid */
        nodeId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentLengthOption[], any>({
        path: `/v1/appointments/appointment-length-options`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name GetFlexibleAppointmentLengthOptions
     * @request GET:/v1/appointments/flexible-appointment-options
     */
    getFlexibleAppointmentLengthOptions: (
      query: {
        practitionerId: number;
        locationId: number;
        /** @format uuid */
        nodeId?: string;
        serviceId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentLengthOption[], any>({
        path: `/v1/appointments/flexible-appointment-options`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name NodeAppointmentSearch
     * @request POST:/v1/appointments/search
     */
    nodeAppointmentSearch: (
      data: SearchNodeAppointmentsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeAppointmentResults, any>({
        path: `/v1/appointments/search`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name NodeSearchSuggestions
     * @request POST:/v1/appointments/search/suggestions
     */
    nodeSearchSuggestions: (
      data: NodeSearchSuggestionsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<SearchAppointmentSuggestion[], any>({
        path: `/v1/appointments/search/suggestions`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name NodeSearchCalendar
     * @request POST:/v1/appointments/search/calendar
     */
    nodeSearchCalendar: (
      data: SearchNodeAppointmentsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CalendarSearchResult[], any>({
        path: `/v1/appointments/search/calendar`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name AvailablePractitionersSearch
     * @request POST:/v1/appointments/search/available-practitioners
     */
    availablePractitionersSearch: (
      data: SearchNodeAppointmentsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentSearchResult[], any>({
        path: `/v1/appointments/search/available-practitioners`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name PractitionerAppointmentSearch
     * @request POST:/v1/appointments/search/practitioner
     */
    practitionerAppointmentSearch: (
      data: AppointmentSearchByPractitionerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PractitionerSearchResult, any>({
        path: `/v1/appointments/search/practitioner`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name PractitionerAppointmentSearchCalendar
     * @request POST:/v1/appointments/search/practitioner/calendar
     */
    practitionerAppointmentSearchCalendar: (
      data: AppointmentSearchByPractitionerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CalendarSearchResult[], any>({
        path: `/v1/appointments/search/practitioner/calendar`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name PractitionerCallbackSearch
     * @request POST:/v1/appointments/search/practitioner/callback
     */
    practitionerCallbackSearch: (
      data: CallbackSearchByPractitionerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PractitionerCallbackSearchResult, any>({
        path: `/v1/appointments/search/practitioner/callback`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name PractitionerCallbackSearchCalendar
     * @request POST:/v1/appointments/search/practitioner/callback/calendar
     */
    practitionerCallbackSearchCalendar: (
      data: CallbackSearchByPractitionerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CalendarSearchResult[], any>({
        path: `/v1/appointments/search/practitioner/callback/calendar`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name GetNodeFlexibleSearchOptions
     * @request GET:/v1/appointments/flexible-search-options
     */
    getNodeFlexibleSearchOptions: (
      query: {
        nodeId: string;
        locations: string[];
      },
      params: RequestParams = {},
    ) =>
      this.http.request<number[], any>({
        path: `/v1/appointments/flexible-search-options`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointments
     * @name AppointmentPrice
     * @request POST:/v1/appointments/appointment-price
     */
    appointmentPrice: (
      data: AppointmentPriceParams,
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentPrice[], any>({
        path: `/v1/appointments/appointment-price`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name InsuranceCompanies
     * @request GET:/v1/insurance/companies
     */
    insuranceCompanies: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<InsuranceCompany[], any>({
        path: `/v1/insurance/companies`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name InsuranceDirectCompensationPermits
     * @request GET:/v1/insurance/direct-compensation-permits
     */
    insuranceDirectCompensationPermits: (
      query: {
        subjectOmUid: number;
        insuranceCompanyId: string;
        lang: string;
        /** Type of incident for insurance claim. May be undefined. */
        incidentType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<GetDirectCompensationPermitsResult[], any>({
        path: `/v1/insurance/direct-compensation-permits`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name InsuranceCustomership
     * @request GET:/v1/insurance/customership
     */
    insuranceCustomership: (
      query: {
        subjectOmUid: number;
        insuranceCompanyId: string;
        lang: string;
        /** Type of incident for insurance claim. May be undefined. */
        incidentType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<GetCustomershipResult, any>({
        path: `/v1/insurance/customership`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name InsuranceOptions
     * @summary Get insurance options information
     * @request GET:/v1/insurance/options
     */
    insuranceOptions: (
      query: {
        subjectOmUid: number;
        insuranceCompanyId: string;
        lang: string;
        /** Type of incident for insurance claim. May be undefined. */
        incidentType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<GetOptionsResult, any>({
        path: `/v1/insurance/options`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name ConceptConsentStatus
     * @request GET:/v1/insurance/concept-consent-status
     */
    conceptConsentStatus: (
      query: {
        subjectOmUid: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ConceptConsentStatus, any>({
        path: `/v1/insurance/concept-consent-status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags insurance
     * @name SaveConceptConsent
     * @request POST:/v1/insurance/concept-consent
     */
    saveConceptConsent: (
      query: {
        subjectOmUid: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/v1/insurance/concept-consent`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetUser
     * @request GET:/v1/user
     */
    getUser: (params: RequestParams = {}) =>
      this.http.request<UserWithDelegateRole, any>({
        path: `/v1/user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name InitsessionJwt
     * @request POST:/v1/user/init-session-jwt
     */
    initsessionJwt: (data: SessionInitParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/user/init-session-jwt`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name InitSessionAv2
     * @request POST:/v1/user/init-session-av2
     */
    initSessionAv2: (data: SessionInitParamsAV2, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/user/init-session-av2`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name Logout
     * @request POST:/v1/user/logout
     */
    logout: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/user/logout`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name Heartbeat
     * @request POST:/v1/user/heartbeat
     */
    heartbeat: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/user/heartbeat`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name Add
     * @request GET:/v1/user/authorizations/add
     */
    add: (
      query: {
        /** @format uri */
        origin: string;
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/v1/user/authorizations/add`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetAuthorizations
     * @request GET:/v1/user/authorizations
     */
    getAuthorizations: (params: RequestParams = {}) =>
      this.http.request<AuthorizedPerson[], any>({
        path: `/v1/user/authorizations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetPrincipalUser
     * @request GET:/v1/user/authorizations/principal/{omUid}
     */
    getPrincipalUser: (omUid: number, params: RequestParams = {}) =>
      this.http.request<User, any>({
        path: `/v1/user/authorizations/principal/${omUid}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags user
     * @name GetOmFeatures
     * @request GET:/v1/user/om-features
     */
    getOmFeatures: (params: RequestParams = {}) =>
      this.http.request<OmFeatureForUser[], any>({
        path: `/v1/user/om-features`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointment-locks
     * @name LockAppointment
     * @request POST:/v1/appointment-locks
     */
    lockAppointment: (
      data: AppointmentLockParams,
      params: RequestParams = {},
    ) =>
      this.http.request<AppointmentLockResult, any>({
        path: `/v1/appointment-locks`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags appointment-locks
     * @name UnlockAppointment
     * @request DELETE:/v1/appointment-locks
     */
    unlockAppointment: (
      data: AppointmentUnlockParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/v1/appointment-locks`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags autocomplete
     * @name AutocompleteNode
     * @request GET:/v1/autocomplete/node
     */
    autocompleteNode: (
      query: {
        searchString: string;
        lang: string;
        limit: number;
        ohc: boolean;
        insuranceContractId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<
        NodeAutocompleteResult[] | NodeAutocompleteResultWithContract[],
        any
      >({
        path: `/v1/autocomplete/node`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags autocomplete
     * @name AutocompleteLocation
     * @request GET:/v1/autocomplete/location
     */
    autocompleteLocation: (
      query: {
        searchString: string;
        lang: string;
        limit: number;
        ohc: boolean;
        nodeId: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<LocationAutocompleteResult[], any>({
        path: `/v1/autocomplete/location`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags event
     * @name PostEvent
     * @request POST:/v1/event
     */
    postEvent: (data: EventRequestBody, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/event`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags event
     * @name AssisdentAppointment
     * @request POST:/v1/event/assisdent/appointment
     */
    assisdentAppointment: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/v1/event/assisdent/appointment`,
        method: "POST",
        ...params,
      }),
  };
  megaAdmin = {
    /**
     * No description
     *
     * @tags mega-admin
     * @name Start
     * @request POST:/mega-admin/start
     */
    start: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/mega-admin/start`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags mega-admin
     * @name Stop
     * @request POST:/mega-admin/stop
     */
    stop: (data: MegaAdminCloseEvent, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/mega-admin/stop`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags mega-admin
     * @name Status
     * @request GET:/mega-admin/status
     */
    status: (params: RequestParams = {}) =>
      this.http.request<MegaAdminStatus, any>({
        path: `/mega-admin/status`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  v2 = {
    /**
     * No description
     *
     * @tags search-nodes-v2
     * @name AllOhcNodes
     * @request GET:/v2/search-nodes/all/ohc
     */
    allOhcNodes: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<SearchNodeWithModals[], any>({
        path: `/v2/search-nodes/all/ohc`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags search-nodes-v2
     * @name AllPrivateNodes
     * @request GET:/v2/search-nodes/all
     */
    allPrivateNodes: (
      query: {
        lang: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<PublicNode[], any>({
        path: `/v2/search-nodes/all`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  parse = {
    /**
     * No description
     *
     * @tags parse
     * @name ParseGet
     * @request GET:/parse/{path}
     */
    parseGet: (
      path: string,
      query: {
        language: string;
        isRedirected: boolean;
        noLanding: boolean;
        envelope: string;
        token: string;
        sourceService: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/parse/${path}`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags parse
     * @name ParsePost
     * @request POST:/parse/{path}
     */
    parsePost: (
      path: string,
      query: {
        language: string;
      },
      data: ParseBodyParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/parse/${path}`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  admin = {
    /**
     * No description
     *
     * @tags admin
     * @name HealthCheck
     * @request GET:/admin/health-check
     */
    healthCheck: (params: RequestParams = {}) =>
      this.http.request<string, any>({
        path: `/admin/health-check`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetUser
     * @request GET:/admin/user
     */
    getUser: (params: RequestParams = {}) =>
      this.http.request<AdminUser, any>({
        path: `/admin/user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name Translations
     * @request GET:/admin/translations
     */
    translations: (params: RequestParams = {}) =>
      this.http.request<Translation[], any>({
        path: `/admin/translations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name Translation
     * @request POST:/admin/translation
     */
    translation: (data: Translation, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/translation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteTranslation
     * @request DELETE:/admin/translation
     */
    deleteTranslation: (data: BaseTranslation, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/translation`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name ClearCache
     * @request GET:/admin/clear-cache
     */
    clearCache: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/clear-cache`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name CacheStats
     * @request GET:/admin/cache-stats
     */
    cacheStats: (
      query: {
        top: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/cache-stats`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name Nodes
     * @request GET:/admin/nodes
     */
    nodes: (params: RequestParams = {}) =>
      this.http.request<SimpleNode[], any>({
        path: `/admin/nodes`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name CreateOrUpdateNode
     * @request PUT:/admin/nodes
     */
    createOrUpdateNode: (data: Node, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/nodes`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name Node
     * @request GET:/admin/nodes/{id}
     */
    node: (id: string, params: RequestParams = {}) =>
      this.http.request<Node, any>({
        path: `/admin/nodes/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteNode
     * @request DELETE:/admin/nodes/{id}
     */
    deleteNode: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/nodes/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PatchNode
     * @request POST:/admin/nodes/{id}/children
     */
    patchNode: (id: string, data: NodeChildren, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/nodes/${id}/children`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetFavorites
     * @request GET:/admin/favorites
     */
    getFavorites: (params: RequestParams = {}) =>
      this.http.request<FavoriteNode[], any>({
        path: `/admin/favorites`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutFavorites
     * @request PUT:/admin/favorites
     */
    putFavorites: (data: string[], params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/favorites`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name SearchTermOptions
     * @request GET:/admin/search-term-options
     */
    searchTermOptions: (params: RequestParams = {}) =>
      this.http.request<SearchTermOption[], any>({
        path: `/admin/search-term-options`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name NodeIcons
     * @request GET:/admin/node-icons
     */
    nodeIcons: (params: RequestParams = {}) =>
      this.http.request<NodeIcon[], any>({
        path: `/admin/node-icons`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name NodeKeywords
     * @request GET:/admin/node-keywords
     */
    nodeKeywords: (params: RequestParams = {}) =>
      this.http.request<NodeKeyword[], any>({
        path: `/admin/node-keywords`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name UpsertKeyword
     * @request PUT:/admin/node-keyword
     */
    upsertKeyword: (data: NodeKeyword, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/node-keyword`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteKeyword
     * @request DELETE:/admin/node-keyword/{id}
     */
    deleteKeyword: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/node-keyword/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name SearchTermConditionOptions
     * @request GET:/admin/node-term-condition-options
     */
    searchTermConditionOptions: (params: RequestParams = {}) =>
      this.http.request<ConditionOption[], any>({
        path: `/admin/node-term-condition-options`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name Locations
     * @request GET:/admin/locations
     */
    locations: (params: RequestParams = {}) =>
      this.http.request<Location[], any>({
        path: `/admin/locations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name NotificationPlaces
     * @request GET:/admin/notifications/places
     */
    notificationPlaces: (params: RequestParams = {}) =>
      this.http.request<NotificationPlace[], any>({
        path: `/admin/notifications/places`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name Notifications
     * @request GET:/admin/notifications
     */
    notifications: (params: RequestParams = {}) =>
      this.http.request<Notification[], any>({
        path: `/admin/notifications`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name CreateOrUpdateNotification
     * @request PUT:/admin/notifications
     */
    createOrUpdateNotification: (
      data: Notification,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/notifications`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name WalkInNotifications
     * @request GET:/admin/notifications/walk-in
     */
    walkInNotifications: (params: RequestParams = {}) =>
      this.http.request<WalkInNotification[], any>({
        path: `/admin/notifications/walk-in`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutWalkInNotification
     * @request PUT:/admin/notifications/walk-in
     */
    putWalkInNotification: (
      data: WalkInNotification,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/notifications/walk-in`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteNotification
     * @request DELETE:/admin/notifications/{id}
     */
    deleteNotification: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/notifications/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetDigitalClinicNotifications
     * @request GET:/admin/notifications/digitalclinic
     */
    getDigitalClinicNotifications: (params: RequestParams = {}) =>
      this.http.request<DigitalClinicNotification[], any>({
        path: `/admin/notifications/digitalclinic`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutDigitalClinicNotifications
     * @request PUT:/admin/notifications/digitalclinic
     */
    putDigitalClinicNotifications: (
      data: DigitalClinicNotification,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/notifications/digitalclinic`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteDigitalClinicNotification
     * @request DELETE:/admin/notifications/digitalclinic/{id}
     */
    deleteDigitalClinicNotification: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/notifications/digitalclinic/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetDigitalClinicQueues
     * @request GET:/admin/notifications/digitalclinic/queues
     */
    getDigitalClinicQueues: (params: RequestParams = {}) =>
      this.http.request<DigitalClinicQueue[], any>({
        path: `/admin/notifications/digitalclinic/queues`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name FeatureFlags
     * @request GET:/admin/feature-flags
     */
    featureFlags: (params: RequestParams = {}) =>
      this.http.request<FeatureFlag[], any>({
        path: `/admin/feature-flags`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetLinkings
     * @request GET:/admin/linkings
     */
    getLinkings: (params: RequestParams = {}) =>
      this.http.request<NodeLinking[], any>({
        path: `/admin/linkings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutLinking
     * @request PUT:/admin/linking
     */
    putLinking: (data: NodeLinkingParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/linking`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteLinking
     * @request DELETE:/admin/linking/{id}
     */
    deleteLinking: (
      id: string,
      query: {
        ohcOnly: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/linking/${id}`,
        method: "DELETE",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetLocationTypes
     * @request GET:/admin/node-location-types
     */
    getLocationTypes: (params: RequestParams = {}) =>
      this.http.request<NodeLocationType[], any>({
        path: `/admin/node-location-types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetSearchHistoryAvailabilityData
     * @request GET:/admin/search-history-availability-data
     */
    getSearchHistoryAvailabilityData: (params: RequestParams = {}) =>
      this.http.request<AvailabilityCheckNodeOverrides, any>({
        path: `/admin/search-history-availability-data`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetLocationSettings
     * @request GET:/admin/location-settings
     */
    getLocationSettings: (params: RequestParams = {}) =>
      this.http.request<LocationSettings[], any>({
        path: `/admin/location-settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutLocationDefaultNodes
     * @request PUT:/admin/location-settings/{locationId}/default-node/{nodeId}
     */
    putLocationDefaultNodes: (
      locationId: number,
      nodeId: string,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/location-settings/${locationId}/default-node/${nodeId}`,
        method: "PUT",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetServices
     * @request GET:/admin/services
     */
    getServices: (params: RequestParams = {}) =>
      this.http.request<AdminNodeService[], any>({
        path: `/admin/services`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutService
     * @request PUT:/admin/service
     */
    putService: (data: AdminNodeService, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/service`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteService
     * @request DELETE:/admin/service/{id}
     */
    deleteService: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/service/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetServiceOptions
     * @request GET:/admin/service-options
     */
    getServiceOptions: (params: RequestParams = {}) =>
      this.http.request<AdminNodeServiceOption[], any>({
        path: `/admin/service-options`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetServicePricings
     * @request GET:/admin/service-pricings
     */
    getServicePricings: (params: RequestParams = {}) =>
      this.http.request<AdminNodeServicePricingOption[], any>({
        path: `/admin/service-pricings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name ServiceContractItems
     * @request GET:/admin/service-contract-items
     */
    serviceContractItems: (params: RequestParams = {}) =>
      this.http.request<ContractItem[], any>({
        path: `/admin/service-contract-items`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetServiceLinkings
     * @request GET:/admin/service-linkings
     */
    getServiceLinkings: (params: RequestParams = {}) =>
      this.http.request<ServiceLinking[], any>({
        path: `/admin/service-linkings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutServiceLinking
     * @request PUT:/admin/service-linking
     */
    putServiceLinking: (
      data: ServiceLinkingParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/service-linking`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteServiceLinking
     * @request DELETE:/admin/service-linking/{id}
     */
    deleteServiceLinking: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/service-linking/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name Modal
     * @request GET:/admin/modal
     */
    modal: (params: RequestParams = {}) =>
      this.http.request<AdminModal[], any>({
        path: `/admin/modal`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutModal
     * @request PUT:/admin/modal
     */
    putModal: (data: AdminModal, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/modal`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteModal
     * @request DELETE:/admin/modal/{id}
     */
    deleteModal: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/modal/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name AssisdentMaintenance
     * @request POST:/admin/assisdent/maintenance
     */
    assisdentMaintenance: (
      data: AssisdentMaintenanceParams,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/assisdent/maintenance`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetParseSelections
     * @request GET:/admin/parse/selections
     */
    getParseSelections: (params: RequestParams = {}) =>
      this.http.request<ParseSelections, any>({
        path: `/admin/parse/selections`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetInsuranceOptions
     * @request GET:/admin/insurance-options
     */
    getInsuranceOptions: (params: RequestParams = {}) =>
      this.http.request<InsuranceOption[], any>({
        path: `/admin/insurance-options`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutInsuranceOption
     * @request PUT:/admin/insurance-options
     */
    putInsuranceOption: (data: InsuranceOption, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/insurance-options`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteInsuranceOption
     * @request DELETE:/admin/insurance-options/{id}
     */
    deleteInsuranceOption: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/insurance-options/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetOmFeatureOptions
     * @request GET:/admin/om-feature/all
     */
    getOmFeatureOptions: (params: RequestParams = {}) =>
      this.http.request<OmFeature[], any>({
        path: `/admin/om-feature/all`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutOmFeature
     * @request PUT:/admin/om-feature
     */
    putOmFeature: (data: OmFeature, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/om-feature`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name UpdateOmFeatureOrder
     * @request PUT:/admin/om-feature/update-order
     */
    updateOmFeatureOrder: (data: OmFeatureOrder, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/om-feature/update-order`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteOmFeature
     * @request DELETE:/admin/om-feature/{id}
     */
    deleteOmFeature: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/om-feature/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetThresholds
     * @request GET:/admin/search-thresholds
     */
    getThresholds: (params: RequestParams = {}) =>
      this.http.request<SearchThresholdItem[], any>({
        path: `/admin/search-thresholds`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name PutThreshold
     * @request PUT:/admin/search-thresholds
     */
    putThreshold: (data: SearchThresholdItem, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/search-thresholds`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteThreshold
     * @request DELETE:/admin/search-thresholds/{id}
     */
    deleteThreshold: (id: string, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/admin/search-thresholds/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name GetAllConfig
     * @request GET:/admin/config
     */
    getAllConfig: (params: RequestParams = {}) =>
      this.http.request<object[], any>({
        path: `/admin/config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name SetAvailabilityCheckConfig
     * @request PUT:/admin/config/availability_check_config
     */
    setAvailabilityCheckConfig: (
      data: AvailabilityCheckConfigValueDto,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/config/availability_check_config`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name SetConfig
     * @request PUT:/admin/config/{key}
     */
    setConfig: (
      key:
        | "search_procedure_v1_percentage"
        | "search_procedure_v2_percentage"
        | "availability_check_config",
      data: ConfigValueDto,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/config/${key}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags admin
     * @name DeleteConfig
     * @request DELETE:/admin/config/{key}
     */
    deleteConfig: (
      key:
        | "search_procedure_v1_percentage"
        | "search_procedure_v2_percentage"
        | "availability_check_config",
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/admin/config/${key}`,
        method: "DELETE",
        ...params,
      }),
  };
  testData = {
    /**
     * No description
     *
     * @tags test-data
     * @name GenerateAppointments
     * @request POST:/test-data/appointments
     */
    generateAppointments: (
      data: CreateTestAppointmentsParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateTestAppointmentsResult[], any>({
        path: `/test-data/appointments`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-data
     * @name CreatePractitioner
     * @request POST:/test-data/practitioner
     */
    createPractitioner: (
      data: CreateTestPractitionerParams,
      params: RequestParams = {},
    ) =>
      this.http.request<CreateTestPractitionerResult, any>({
        path: `/test-data/practitioner`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags test-data
     * @name DeleteTestData
     * @request DELETE:/test-data
     */
    deleteTestData: (data: DeleteTestDataParams, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/test-data`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
}
